import { getLeadersText } from '@/utils/common'

export const getEventsFromDates = (fromDate, toDate, events) => {
  const from = new Date(fromDate).getTime()
  const to = new Date(toDate).getTime()
  return events.filter(event => {
    const eventTime = new Date(event.startDate).getTime()
    return from <= eventTime && eventTime <= to
  })
}

export const getEventsPerLeader = (fromDate, toDate, events, leadersMap) => {
  const list = getEventsFromDates(fromDate, toDate, events)
  const acum = list.reduce((acc, event) => {
    const leaders = Array.isArray(event.leaders)
      ? event.leaders.filter(leaderId => leaderId && leadersMap[leaderId])
      : []

    if (leaders.length) {
      const acumL = leaders.reduce(
        (accL, leaderId) => ({
          ...accL,
          [leaderId]: (acc[leaderId] || 0) + 1
        }),
        {}
      )
      return { ...acc, ...acumL }
    }
    return acc
  }, {})
  return Object.keys(acum).map(key => {
    const leader = leadersMap[key]
    return {
      id: key,
      leader: getLeadersText([key], leadersMap),
      email: leader.email,
      count: acum[key]
    }
  })
}
